var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 259,
    viewBox: "0 0 287 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_563)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 287,
    height: 259
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 0H0V259H287V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.3 44.6C92.8998 47.5 77.0998 48 61.6998 50.7C40.7998 54.4 20.7998 60.6 9.59981 80C-1.40019 98.9 -3.40019 124 6.39981 143.8C13.4998 158.2 24.5998 171.8 38.1998 180.4C55.4998 191.3 74.5998 199.6 94.3998 204.8C116 210.5 139.1 212.7 158.1 224.4C168.1 230.5 176.4 239 186.3 245.2C207.5 258.4 235.9 260 257.5 247.4C279 234.7 291.7 207.7 285.7 183.4C281.9 168.1 271.8 155.3 266.2 140.6C261.4 128 259.9 114.2 262.1 100.9C264.3 87.2 270.1 74.3 271.5 60.4C272.7 48.8 268.6 34.1 262.2 24.3C248.9 4.4 225.1 -2.7 202.6 0.899996C185.6 3.6 168.9 12.1 154.7 21.6C148 26.1 142.8 32.1 135.3 35.9C127.6 39.8 119.3 42.4 110.9 44.1L108.2 44.7H108.3V44.6Z",
    fill: "#2F32FE",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5996 81.3L28.7996 88.5",
    stroke: "#2F32FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5996 88.5L28.7996 81.3",
    stroke: "#2F32FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.8 221.1L213 228.3",
    stroke: "#2F32FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.8 228.3L213 221.1",
    stroke: "#2F32FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6 106.7L283.8 113.9",
    stroke: "#2F32FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6 113.9L283.8 106.7",
    stroke: "#2F32FE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8998 108.6C82.1998 108.6 84.9998 105.9 84.9998 102.5C84.9998 99.1 82.2998 96.4 78.8998 96.4C75.4998 96.4 72.7998 99.1 72.7998 102.5C72.7998 105.9 75.4998 108.6 78.8998 108.6Z",
    stroke: "#2F32FE",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8996 26.2C64.2996 26.2 66.1996 24.3 66.1996 21.9C66.1996 19.5 64.2996 17.6 61.8996 17.6C59.4996 17.6 57.5996 19.5 57.5996 21.9C57.5996 24.3 59.4996 26.2 61.8996 26.2Z",
    stroke: "#2F32FE",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.3 170.7C259.7 170.7 261.6 168.8 261.6 166.4C261.6 164 259.7 162.1 257.3 162.1C254.9 162.1 253 164 253 166.4C253 168.8 254.9 170.7 257.3 170.7Z",
    stroke: "#2F32FE",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7 26.5C206.5 26.5 209.6 23.4 209.6 19.6C209.6 15.8 206.5 12.7 202.7 12.7C198.9 12.7 195.8 15.8 195.8 19.6C195.8 23.4 198.9 26.5 202.7 26.5Z",
    stroke: "#2F32FE",
    strokeWidth: 1.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 145.1V210.9C37.5 216.2 41.9 220.5 47.4 220.5H60.7V256.9L102 220.5H147.6C153 220.5 157.5 216.2 157.5 210.9V139.6C157.5 134.3 153.1 130 147.6 130H61.4",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4 62.2V140.7C248.4 146.8 243.3 151.8 237 151.8H221.6V194L173.7 151.8H157.5",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 130V58.2C109.5 52.1 114.6 47.1 120.9 47.1H224.6",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 193H134.5",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 172H134.5",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 123.5H230.5",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 102.5H230.5",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 81.5H230.5",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1 57.8C253 53.1 247.9 49.8 242.5 49.8C237.1 49.8 232 53.1 229.9 57.8",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6 63.2001C252.5 63.2001 260.6 55.2 260.6 45.3C260.6 35.4 252.6 27.3 242.6 27.3C232.6 27.3 224.7 35.3 224.7 45.3C224.7 55.3 232.7 63.2001 242.6 63.2001Z",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6 45.2C245 45.2 247 43.2 247 40.8C247 38.4 245 36.4 242.6 36.4C240.2 36.4 238.2 38.4 238.2 40.8C238.2 43.2 240.2 45.2 242.6 45.2Z",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0999 140.8C53.9999 136.1 48.8999 132.8 43.4999 132.8C38.0999 132.8 32.9999 136.1 30.8999 140.8",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5997 146.2C53.4997 146.2 61.5997 138.2 61.5997 128.2C61.5997 118.2 53.5997 110.3 43.5997 110.3C33.5997 110.3 25.6997 118.3 25.6997 128.2C25.6997 138.1 33.6997 146.2 43.5997 146.2Z",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5997 128.2C45.9997 128.2 47.9997 126.2 47.9997 123.8C47.9997 121.4 45.9997 119.4 43.5997 119.4C41.1997 119.4 39.1997 121.4 39.1997 123.8C39.1997 126.2 41.1997 128.2 43.5997 128.2Z",
    stroke: "#2F32FE",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 259,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLight);
export default __webpack_public_path__ + "static/media/empty-light.cc80ef7b.svg";
export { ForwardRef as ReactComponent };